import { Col, Row } from "react-bootstrap";
import "./BlockContentControls.css";

const BlockContentControls = (props: any) => {
  return (
    <>
      <Row
        className={`justify-content-center block-content-fitprenda-controls px-${
          props.paddingX || 5
        } py-4`}
      >
        <Col>{props.children || "Content Empty"}</Col>
      </Row>
    </>
  );
};

export default BlockContentControls;
